import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class LicencaEventoService extends BaseService {
  constructor() {
    super(`${ConfigApi.licencaEventoURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.idCliente = undefined;
    this.idLicencaInstalacao = undefined;
    this.tipo = undefined;
    this.limit = 50;
    this.page = 0;
  }
}
export default new LicencaEventoService();
